module.exports = __webpack_public_path__ + "media/sofa_marker_cn.ae821b96.mp4";